/**
 * Utility functions for formatting data
 */
export const formatPopulation = (num) => {
  if (num < 1000) {
    return num.toLocaleString();
  } else if (num < 1000000) {
    const divided = num / 1000;
    // If we're very close to 1000.0K, convert to 1.0M instead
    if (divided >= 999.5) {
      return '1.0M';
    }
    if (Number.isInteger(divided)) {
      return divided.toLocaleString() + 'K';
    } else {
      return divided.toFixed(1) + 'K';
    }
  } else {
    const divided = num / 1000000;
    return divided.toFixed(1) + 'M';
  }
};

export default {
  formatPopulation
};